import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api, extractError } from "@/api/client";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Undo2 } from "lucide-react";

export default function UndoButton({ compact = false }) {
  const qc = useQueryClient();
  const [step, setStep] = useState(0);
  const { data: last } = useQuery({
    queryKey: ["undo-last"],
    queryFn: async () => (await api.get("/undo/last")).data,
    refetchInterval: 15000,
  });
  const undoMut = useMutation({
    mutationFn: async () => (await api.post("/undo/last")).data,
    onSuccess: (d) => {
      toast.success(d.message);
      setStep(0);
      qc.invalidateQueries();
    },
    onError: (e) => { toast.error(extractError(e)); setStep(0); },
  });
  if (!last) return null;
  const when = new Date(last.at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });

  if (step === 0) {
    return (
      <Button variant="outline" size="sm" className="h-9 rounded-full" onClick={() => setStep(1)} title={`${last.label} · ${when}`} data-testid="undo-btn">
        <Undo2 className="w-4 h-4" />{!compact && <span className="ml-1 max-w-[220px] truncate">Annulla: {last.label}</span>}
      </Button>
    );
  }
  return (
    <div className={`flex items-center gap-2 rounded-2xl border px-3 py-1.5 text-xs ${step === 2 ? "border-rose-300 bg-rose-50" : "border-amber-300 bg-amber-50"}`} data-testid="undo-confirm-box">
      <span className="max-w-[260px] truncate">{step === 1 ? `Annullare «${last.label}» (${when})?` : "Ultima conferma: annullo davvero?"}</span>
      <Button size="sm" variant="ghost" className="h-7" onClick={() => setStep(0)} data-testid="undo-cancel-btn">No</Button>
      {step === 1 && <Button size="sm" className="h-7 bg-amber-600 hover:bg-amber-700" onClick={() => setStep(2)} data-testid="undo-step1-btn">Sì</Button>}
      {step === 2 && <Button size="sm" className="h-7 bg-rose-600 hover:bg-rose-700" disabled={undoMut.isPending} onClick={() => undoMut.mutate()} data-testid="undo-step2-btn">Annulla definitivamente</Button>}
    </div>
  );
}
